import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().min(1, "Required").email("Enter a valid email"),
  password: z.string().min(1, "Required"),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
